'use strict';
angular.module('wechatModal', []).controller('wechatModalCtrl', [
    '$q',
    '$modalInstance',
    '$scope',
    'selected',
    'trsHttpService',
    'modalDialog',
    function($q, $modalInstance, $scope, selected, trsHttpService, modalDialog) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
                PAGECOUNT: 0,
                ITEMCOUNT: 0,
            };
            $scope.status = {
                selectedArr: [], // 选中数组
            };
            $scope.params = {
                methodname: 'queryAccounts',
                serviceid: 'mlf_kuaibaoaccount',
            };
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.data = {
                bindedCount: [], //已经绑定的企鹅号
                selectedQiehao: selected || [], //选中的企鹅号数据
                items: [], //企鹅号数据
            };
            requestData();
        }
        /**
         * [getReportGroup description] 请求企鹅号数据
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var defer = $q.defer();
            ($scope.params.PageIndex = $scope.page.CURRPAGE),
                ($scope.LoadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.items = data.DATA;

                    queryBindedKuaiBaoCout();

                    defer.resolve();
                }));
            return defer.promise;
        }
        /**
         * [queryBindedKuaiBaoCout description]显示当前已经绑定的企鹅号账户
         *
         */
        function queryBindedKuaiBaoCout() {
            $scope.data.bindedCount = $scope.data.items.filter((item) => {
                return item.KUAIBAOACCOUNTID === selected.KUAIBAOACCOUNTID;
            });
        }

        /**
         * [selectedReport description] 企鹅号选择操作操作
         * @param   {[type]}  item  [item description] 选中的企鹅号
         * @return  {[type]}  [return description]
         */
        $scope.selectedQiehao = function(item) {
            if ($scope.data.selectedQiehao.KUAIBAOACCOUNTID === item.KUAIBAOACCOUNTID) {
                $scope.data.selectedQiehao = [];
            } else {
                $scope.data.selectedQiehao = item;
            }
        };

        /**
         *[close description] 取消按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定按钮操作
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            if ($scope.data.selectedQiehao.length == '0') {
                modalDialog.confirmModal('提醒', '确定要解绑吗', function() {
                    $modalInstance.close({
                        data: $scope.data.selectedQiehao,
                    });
                });
            } else {
                $modalInstance.close({
                    data: $scope.data.selectedQiehao,
                });
            }
        };
    },
]);
